import {
  WELLBORE_TYPE_DIRECTORY_OBJECTS,
  withWellboreTypeEnrichment,
  type IReferenceWellsFullInfoApi,
} from '@repo/reference-wells';

import { requireService } from 'src/packages/di';
import type { IDirectoriesService } from 'src/packages/directories/IDirectoriesService';

/**
 * Wraps transport full-info API and enriches wellbores from directories.
 * Keeps ReferenceWellsFullInfoApi as pure transport.
 */
export function createEnrichedReferenceWellsFullInfoApi(
  inner: IReferenceWellsFullInfoApi,
  directories: IDirectoriesService = requireService('directories'),
): IReferenceWellsFullInfoApi {
  return withWellboreTypeEnrichment(inner, async () => {
    await directories.loadObjects([...WELLBORE_TYPE_DIRECTORY_OBJECTS]);

    return {
      types: directories.getObject('Common_WellboreType'),
      instances: directories.getObject('Common_WellboreTypeInstance'),
    };
  });
}
